/* eslint-disable array-callback-return */
/* eslint-disable react-hooks/exhaustive-deps */
import * as yup from "yup";
import React, { useEffect, useMemo, useState } from "react";

import { Box, Button, Card, CardContent, Grid, Tooltip } from "@mui/material";
import {
    CheckCircle,
    Clear,
    DoneAll,
    DriveFileMoveRounded,
    FileDownloadOutlined,
    FileUploadOutlined,
    Grading,
    Mail,
    MonetizationOn,
    PlayCircle,
    Search,
    Send,
    Settings,
    Report,
} from "@mui/icons-material";
import {
    GridActionsCellItem,
    GridRowId,
    GridRowModel,
    GridRowSelectionModel,
    GridSortDirection,
    GridSortModel,
} from "@mui/x-data-grid";
import { format } from "date-fns";
import { toast } from "react-toastify";
import useThrowAsyncError from "@/hooks/useThrowAsyncError";
import { useForm } from "react-hook-form";
import { useHistory } from "react-router-dom";
import { yupResolver } from "@hookform/resolvers/yup";

import AutoComplete from "@/components/hookForms/autoComplete";
import AutoCompleteMulti from "@/components/hookForms/autoCompleteMult";
import { Container } from "@/theme/globalStyles";
import DataTable from "../../../components/dataTable";
import Datapicker from "@/components/hookForms/datePicker";
import DialogInfo from "@/components/informationDialog";
import DialogLoad from "./modal/dialogLoad";
import DialogConfirmRestart from "./modal/dialogRestart";
import IGenericResult from "@/interfaces/IGenericResult";
import { downloadFileFromBase64 } from "../../../utils/utils";
import messages from "@/utils/messages";
import serviceConcessionaria from "@/services/serviceConcessionaria";
import serviceRebalanceUsina from "@/services/serviceRebalanceUsina";
import { useAuth } from "../../../context/global";
import DialogError from "./modal/dialogError";
import DialogGanhoFinanceiro from "./modal/dialogGanhoFinanceiro";
import ButtonDownload from "./components/buttonDownload";

const Rebalance: React.FC = (props: any) => {
    const { setTitlePage } = useAuth();
    const history = useHistory();

    useEffect(() => {
        setTitlePage("Rebalance - Rebalance");
    }, [setTitlePage]);

    const [usinaDataOptions, setUsinaDataOptions] = useState<any[]>([]);
    const [statusDataOptions, setStatusDataOptions] = useState<any[]>([]);
    const [concessionariaDataOptions, setConcessionariaDataOptions] = useState<IGenericResult[]>([]);
    const [data, setData] = useState<any[]>([]);
    const [pageSize, setPageSize] = useState(100);
    const [page, setPage] = useState(0);
    const [filters, setFilters] = useState(null);
    const [rowCount, setRowCount] = useState(0);
    const [isLoading, setLoading] = useState(false);
    const [linesSelecteds, setLinesSelecteds] = useState<GridRowSelectionModel>([]);
    const [dataMessages, setDataMessages] = useState<string[]>([]);
    const [infoModal, setInfoModal] = useState(false);
    const [confirmRestartModal, setConfirmRestartModal] = useState(false);
    const [openImport, setOpenImport] = useState(false);

    const [iniciarDisabled, setIniciarDisabled] = useState(false);
    const [downloadDisabled, setDownloadDisabled] = useState(false);
    const [processarDisabled, setProcessarDisabled] = useState(false);
    const [aprovarDisabled, setAprovarDisabled] = useState(false);
    const [reabrirDisabled, setReabrirDisabled] = useState(false);
    const [enviarDisabled, setEnviarDisabled] = useState(false);
    const [sankhyaDisabled, setSankhyaDisabled] = useState(false);
    const [aprovConcDisabled, setAprovConcDisabled] = useState(false);
    const [errorState, setErrorState] = useState({ open: false, id: "", error: "", rebalanceUsinaID: "" });
    const [ganhoFinanceiroModal, setGanhoFinanceiroModal] = useState(false);
    const [ganhoFinanceiroState, setGanhoFinanceiroState] = useState({ usinaID: 0, mes: "", ano: "" });
    const [confirmRestartState, setConfirmRestartState] = useState({
        usinaID: 0,
        rebalanceUsinaID: 0,
        nomeUsina: "",
        cicloFaturamento: "",
    });

    const [sortModel, setSortModel] = useState<GridSortModel>([
        {
            field: "",
            sort: "" as GridSortDirection,
        },
    ]);

    const confirmRestartStatus = [
        "Aberto",
        "Aguardando processamento",
        "Erro",
        "Processado",
        "Aprovado",
        "A iniciar",
        "Sem Movimento",
    ];

    const blockRestartStatus = [
        "Enviado Concessionária",
        "Enviado Sankhya",
        "Aguardando Consolidação",
        "Enviando Sankhya",
        "Erro Sankhya",
    ];

    const ganhoFinanceiroEnabledStatus = [
        "Aprovado",
        "Enviado Concessionária",
        "Aprovado Concessionária",
        "Enviado Sankhya",
    ];

    const validationSchema = yup.object().shape({
        cicloFaturamento: yup.date().required(messages.requiredField).typeError(messages.invalidDate),
    });

    const {
        control,
        handleSubmit,
        reset,
        formState: { errors },
        // eslint-disable-next-line react-hooks/rules-of-hooks
    } = useForm({
        resolver: yupResolver(validationSchema),
        defaultValues: {
            cicloFaturamento: null || new Date(),
            concessionariaID: "",
            usinasIds: "",
            status: "",
            tipoUsina: "",
        },
    });

    const actionColumns = useMemo(
        () => [
            {
                headerName: "Operação",
                field: "operations",
                type: "actions",
                width: 440,
                hide: false,
                getActions: (params: { id: GridRowId; row: GridRowModel }) => [
                    <GridActionsCellItem
                        icon={
                            <Tooltip title="Detalhar">
                                <Grading />
                            </Tooltip>
                        }
                        label="Detalhar"
                        onClick={() => {
                            history.push("/rebalance/detalhar", {
                                rebalanceUsinaID: params.row.rebalanceUsinaID,
                                usinaID: params.row.usinaID,
                                status: params.row.status,
                                filterOld: filters,
                            });
                        }}
                        disabled={
                            params.row.status === "A iniciar" ||
                            params.row.status === "Sem Movimento" ||
                            iniciarDisabled
                        }
                    />,
                    <GridActionsCellItem
                        icon={
                            <Tooltip title="Iniciar">
                                <PlayCircle />
                            </Tooltip>
                        }
                        label="Iniciar"
                        onClick={() => {
                            if (confirmRestartStatus.slice(0, 5).includes(params.row.status)) {
                                setConfirmRestartState({
                                    cicloFaturamento: params.row.cicloFaturamento,
                                    nomeUsina: params.row.nomeUsina,
                                    rebalanceUsinaID: params.row.rebalanceUsinaID,
                                    usinaID: params.row.usinaID,
                                });
                                setConfirmRestartModal(true);
                                return;
                            }
                            serviceStart(params.row.usinaID.toString(), params.row.cicloFaturamento);
                        }}
                        disabled={!confirmRestartStatus.includes(params.row.status)}
                    />,
                    <GridActionsCellItem
                        icon={
                            <Tooltip title="Download">
                                <FileDownloadOutlined />
                            </Tooltip>
                        }
                        label="Download"
                        onClick={() => {
                            serviceDownload(params.row.usinaID.toString(), params.row.cicloFaturamento);
                        }}
                    />,

                    <GridActionsCellItem
                        icon={
                            <Tooltip title="Processar">
                                <Settings />
                            </Tooltip>
                        }
                        label="Processar"
                        onClick={() => {
                            serviceProcess(params.row.usinaID.toString(), params.row.cicloFaturamento);
                        }}
                        disabled={
                            (params.row.status !== "Aberto" &&
                                params.row.status !== "Erro" &&
                                params.row.status !== "Processado") ||
                            processarDisabled
                        }
                    />,
                    <GridActionsCellItem
                        icon={
                            <Tooltip title="Aprovar">
                                <CheckCircle />
                            </Tooltip>
                        }
                        label="Aprovar"
                        onClick={() => {
                            serviceApprove(params.row.rebalanceUsinaID.toString());
                        }}
                        disabled={params.row.status !== "Processado" || aprovarDisabled}
                    />,
                    <GridActionsCellItem
                        icon={
                            <Tooltip title="Reabrir">
                                <DriveFileMoveRounded />
                            </Tooltip>
                        }
                        label="Reabrir"
                        onClick={() => {
                            serviceReopen(params.row.rebalanceUsinaID.toString());
                        }}
                        disabled={
                            (params.row.status !== "Aprovado" && params.row.status !== "Enviado Concessionária") ||
                            reabrirDisabled
                        }
                    />,
                    <GridActionsCellItem
                        icon={
                            <Tooltip title="Enviar Concessionária">
                                <Mail />
                            </Tooltip>
                        }
                        label="Enviar Concessionária"
                        onClick={() => {
                            serviceSendConcessionaria(params.row.usinaID.toString(), params.row.cicloFaturamento);
                        }}
                        disabled={
                            (params.row.status !== "Aprovado" && params.row.status !== "Enviado Concessionária") ||
                            enviarDisabled
                        }
                    />,
                    <GridActionsCellItem
                        icon={
                            <Tooltip title="Sankhya">
                                <Send />
                            </Tooltip>
                        }
                        label="Sankhya"
                        onClick={() => {
                            serviceSankhya(params.row.usinaID.toString(), params.row.cicloFaturamento);
                        }}
                        disabled={
                            (params.row.status !== "Enviado Concessionária" && params.row.status !== "Erro Sankhya") ||
                            sankhyaDisabled
                        }
                    />,
                    <GridActionsCellItem
                        icon={
                            <Tooltip title="Aprovar Concessionária">
                                <DoneAll />
                            </Tooltip>
                        }
                        label="Aprovar Concessionária"
                        onClick={() => {
                            serviceApproveConcessionaria(params.row.rebalanceUsinaID.toString());
                        }}
                        disabled={params.row.status !== "Enviado Sankhya" || aprovConcDisabled}
                    />,
                    <GridActionsCellItem
                        icon={
                            <Tooltip title="Erros">
                                <Report />
                            </Tooltip>
                        }
                        label="Erros"
                        onClick={async () => {
                            setErrorState({
                                open: true,
                                id: params.id.toString(),
                                rebalanceUsinaID: params.row.rebalanceUsinaID.toString(),
                                error: "",
                            });
                        }}
                        disabled={params.row.status !== "Erro" && params.row.status !== "Erro Sankhya"}
                    />,
                    <GridActionsCellItem
                        icon={
                            <Tooltip title="Ganho Financeiro">
                                <MonetizationOn />
                            </Tooltip>
                        }
                        label="Ganho Financeiro"
                        onClick={() => {
                            setGanhoFinanceiroState({
                                usinaID: params.row.usinaID,
                                mes: params.row.cicloFaturamento.toString().substring(0, 2),
                                ano: params.row.cicloFaturamento.toString().substring(3),
                            });
                            setGanhoFinanceiroModal(true);
                        }}
                        disabled={!ganhoFinanceiroEnabledStatus.includes(params.row.status)}
                    />,
                ],
            },
        ],
        [filters]
    );

    const columns = useMemo(
        () => [
            {
                headerName: "ID",
                field: "rebalanceUsinaID",
                type: "number",
                headerAlign: "left",
                identity: true,
                width: 70,
            },
            {
                headerName: "Concessionária",
                field: "nomeConcessionaria",
                type: "string",
                width: 180,
            },
            {
                headerName: "Usina",
                field: "nomeUsina",
                type: "string",
                width: 300,
            },
            {
                headerName: "Status",
                field: "status",
                type: "string",
                width: 200,
            },
            {
                headerName: "Empresa usina",
                field: "empresaUsina",
                type: "string",
                width: 140,
            },
            {
                headerName: "Potência (kWp)",
                field: "potenciaKwp",
                type: "number",
                width: 180,
            },
            {
                headerName: "Potência conec.(Mês ant.)",
                field: "potenciaConectada",
                type: "number",
                width: 180,
            },
            {
                headerName: "Potência antes rebalance",
                field: "potenciaAntesRebalance",
                type: "number",
                width: 180,
            },
            {
                headerName: "Dif. a ser conec.",
                field: "diferencaSerConectada",
                type: "number",
                width: 180,
            },
            {
                headerName: "Potência após",
                field: "potenciaAposRebalance",
                type: "number",
                width: 180,
            },
            {
                headerName: "Vacância/Overbooking",
                field: "vacancia",
                type: "number",
                width: 180,
            },
            {
                headerName: "Qtd. Ucs",
                field: "quantidadeUC",
                type: "string",
                width: 120,
            },
            {
                headerName: "Saldo",
                field: "saldo",
                type: "string",
                width: 180,
            },
            {
                headerName: "Prev. Consumo",
                field: "previsaoConsumo",
                type: "string",
                width: 180,
            },
            {
                headerName: "Prev. Geração",
                field: "previsaoGeracao",
                type: "string",
                width: 180,
            },
            {
                headerName: "Prev. Injeção",
                field: "previsaoInjecao",
                type: "string",
                width: 180,
            },
            ...actionColumns,
        ],
        [actionColumns]
    );

    useEffect(() => {
        setConcessionariaData();
        setDataStatus();
    }, []);

    useEffect(() => {
        if (props && props.location && props.location.state) {
            setFilters(props.location.state);
            const newValues = {
                ...props.location.state,
                usinasIds: Array.isArray(props.location.state.usinasIds)
                    ? props.location.state.usinasIds.join(",")
                    : props.location.state.usinasIds,
            };

            getUsinaData({ concessionariaID: props.location.state.concessionariaID });
            getAllWithFilters(newValues);
            reset({ ...props.location.state });
        }
    }, [props]);

    const setDataStatus = () => {
        serviceRebalanceUsina
            .getStatusRebalance()
            .then((result) => {
                if (result) {
                    setStatusDataOptions(result?.data);
                }
            })
            .catch(() => {
                setStatusDataOptions([]);
            });
    };

    const getUsinaData = async (values: any) => {
        if (values.concessionariaID) {
            serviceRebalanceUsina
                .getUsinasByConcessionaria(values)
                .then((result) => {
                    if (result) {
                        setUsinaDataOptions(result?.data);
                    }
                })
                .catch(() => {
                    setUsinaDataOptions([]);
                });
        }
    };

    const setConcessionariaData = async () => {
        serviceConcessionaria
            .getConcessionarias()
            .then((result) => {
                setConcessionariaDataOptions(result?.data);
            })
            .catch(() => {
                setConcessionariaDataOptions([]);
            });
    };

    const throwAsyncError = useThrowAsyncError();

    const getAllWithFilters = async (filters: any) => {
        setData([]);
        setLoading(true);

        const newValues = {
            ...filters,
            concessionariaID: filters?.concessionariaID || "",
            cicloFaturamento: filters?.cicloFaturamento
                ? format(filters?.cicloFaturamento, "MM/yyyy")
                : format(new Date(), "MM/yyyy"),
        };

        serviceRebalanceUsina
            .getWithFilter({
                ...newValues,
                take: pageSize,
                currentPage: page + 1,
                sortExpression: sortModel[0]?.field ?? "",
                sortDirection: sortModel[0]?.sort ?? "",
            })
            .then((result) => {
                if (!result) {
                    throw new Error("Falha ao carregar os dados.");
                }
                setData(result.data.content);
                setRowCount(result.data.numberOfElements);
            })
            .catch((err) => {
                setData([]);
                setRowCount(0);
                throwAsyncError(err);
            })
            .finally(() => {
                setLoading(false);
            });
    };

    useEffect(() => {
        if (!props.location.state) {
            getAllWithFilters(filters);
        }
    }, [page, pageSize, sortModel]);

    const onSubmit = (values: any) => {
        const newValues = {
            ...values,
            usinasIds: values.usinasIds ? values.usinasIds.join(",") : "",
            tipoUsina: values.tipoUsina === "Todos" ? "" : values.tipoUsina,
        };

        setFilters(newValues);
        getAllWithFilters(newValues);
    };

    function serviceStart(ids, cicloFaturamento) {
        setIniciarDisabled(true);
        setLoading(true);

        let newValues = {
            usinasIds: ids,
            mes: cicloFaturamento.toString().substring(0, 2),
            ano: cicloFaturamento.toString().substring(3),
        };

        serviceRebalanceUsina
            .start(newValues)
            .then((response) => {
                if (response) {
                    toast.info("O Rebalance será iniciado para a(s) usina(s) selecionada(s), por favor aguarde.");
                    getAllWithFilters(filters);
                }
            })
            .finally(() => {
                setIniciarDisabled(false);
                setLoading(false);
            });
    }

    function serviceProcess(ids, cicloFaturamento) {
        setProcessarDisabled(true);
        setLoading(true);

        const newValues = {
            usinasIds: ids,
            mes: cicloFaturamento.toString().substring(0, 2),
            ano: cicloFaturamento.toString().substring(3),
        };

        serviceRebalanceUsina
            .process(newValues)
            .then((response) => {
                if (response) {
                    toast.info("O Rebalance será processado para a(s) usina(s) selecionada(s), por favor aguarde.");
                    getAllWithFilters(filters);
                }
            })
            .finally(() => {
                setProcessarDisabled(false);
                setLoading(false);
            });
    }

    function serviceDownload(ids, cicloFaturamento) {
        setDownloadDisabled(true);
        setLoading(true);

        const newValues = {
            usinasIds: ids,
            mes: cicloFaturamento.toString().substring(0, 2),
            ano: cicloFaturamento.toString().substring(3),
        };

        serviceRebalanceUsina
            .download(newValues)
            .then((base64) => {
                if (base64 && base64.data) {
                    downloadFileFromBase64(base64.data, "rebalance", "csv");
                }
            })
            .finally(() => {
                setDownloadDisabled(false);
                setLoading(false);
            });
    }

    function serviceSankhya(ids, cicloFaturamento) {
        setSankhyaDisabled(true);
        setLoading(true);

        const newValues = {
            usinasIds: ids,
            mes: cicloFaturamento.toString().substring(0, 2),
            ano: cicloFaturamento.toString().substring(3),
        };

        serviceRebalanceUsina
            .sankhya(newValues)
            .then((response) => {
                if (response) {
                    toast.info("A sincronização será processada para a(s) usina(s) selecionada(s), por favor aguarde.");
                    getAllWithFilters(filters);
                }
            })
            .finally(() => {
                setSankhyaDisabled(false);
                setLoading(false);
            });
    }

    function serviceApprove(ids) {
        setAprovarDisabled(true);
        setLoading(true);

        const newValues = {
            rebalanceUsinaIds: ids,
        };

        serviceRebalanceUsina
            .approve(newValues)
            .then((response) => {
                if (response) {
                    toast.success("Rebalance aprovado com sucesso para a(s) usina(s) selecionada(s).");
                    getAllWithFilters(filters);
                }
            })
            .finally(() => {
                setAprovarDisabled(false);
                setLoading(false);
            });
    }

    function serviceReopen(ids) {
        setReabrirDisabled(true);
        setLoading(true);

        const newValues = {
            rebalanceUsinaIds: ids,
        };

        serviceRebalanceUsina
            .reopen(newValues)
            .then((response) => {
                if (response) {
                    toast.success("Rebalance reaberto com sucesso para a(s) usina(s) selecionada(s).");
                    getAllWithFilters(filters);
                }
            })
            .finally(() => {
                setReabrirDisabled(false);
                setLoading(false);
            });
    }

    function serviceApproveConcessionaria(ids) {
        setAprovConcDisabled(true);
        setLoading(true);

        const newValues = {
            rebalanceUsinaIds: ids,
        };

        serviceRebalanceUsina
            .approveConcessionaria(newValues)
            .then((response) => {
                if (response.data) {
                    if (response.data.avisos && response.data.avisos.length > 0) {
                        setDataMessages(response.data.avisos);
                    } else {
                        toast.success(
                            "Rebalance aprovado concessionária com sucesso para a(s) usina(s) selecionada(s)."
                        );
                        getAllWithFilters(filters);
                    }
                }
            })
            .finally(() => {
                setAprovConcDisabled(false);
                setLoading(false);
            });
    }

    function serviceSendConcessionaria(ids, cicloFaturamento) {
        setEnviarDisabled(true);
        setLoading(true);

        const newValues = {
            usinasIds: ids,
            mes: cicloFaturamento.toString().substring(0, 2),
            ano: cicloFaturamento.toString().substring(3),
        };

        serviceRebalanceUsina
            .sendConcessionaria(newValues)
            .then((response) => {
                if (response) {
                    toast.info("Os arquivos serão gerados e enviados aos e-mails configurados, por favor aguarde.");
                    getAllWithFilters(filters);
                }
            })
            .finally(() => {
                setEnviarDisabled(false);
                setLoading(false);
            });
    }

    function execList(verb: string) {
        const selecteds = data.filter((item) => linesSelecteds.includes(item.rebalanceUsinaID));

        const enableRestartLines = selecteds.filter((item) => confirmRestartStatus.slice(0, 5).includes(item.status));

        if (verb === "start" && enableRestartLines.length === 1) {
            setConfirmRestartState({
                cicloFaturamento: enableRestartLines[0].cicloFaturamento,
                nomeUsina: enableRestartLines[0].nomeUsina,
                rebalanceUsinaID: enableRestartLines[0].rebalanceUsinaID,
                usinaID: enableRestartLines[0].usinaID,
            });
            setConfirmRestartModal(true);
            return;
        }

        let arrayMenssages: string[] = [];
        let listIds: number[] = [];

        if (selecteds.length > 0) {
            selecteds.map((value) => {
                if (verb === "start") {
                    if (value.status.toLowerCase() === "a iniciar" || value.status.toLowerCase() === "sem movimento") {
                        listIds.push(value.usinaID);
                    } else if (blockRestartStatus.includes(value.status)) {
                        arrayMenssages.push(
                            `Rebalance já iniciado para a usina: ${value.nomeUsina} - ID: ${value.rebalanceUsinaID}`
                        );
                    }
                } else if (verb === "process") {
                    if (
                        value.status.toLowerCase() !== "aberto" &&
                        value.status.toLowerCase() !== "erro" &&
                        value.status.toLowerCase() !== "processado" &&
                        value.status.toLowerCase() !== "aguardando processamento"
                    ) {
                        arrayMenssages.push(
                            `Rebalance não pode ser processado para a usina: ${value.nomeUsina} - ID: ${value.rebalanceUsinaID}`
                        );
                    } else {
                        listIds.push(value.usinaID);
                    }
                } else if (verb === "download") {
                    listIds.push(value.usinaID);
                } else if (verb === "sankhya") {
                    if (
                        value.status.toLowerCase() !== "enviado concessionária" &&
                        value.status.toLowerCase() !== "erro sankhya"
                    ) {
                        arrayMenssages.push(
                            `A sincronização não pode ser processada para a usina: ${value.nomeUsina} - ID: ${value.rebalanceUsinaID}`
                        );
                    } else {
                        listIds.push(value.usinaID);
                    }
                } else if (verb === "approve") {
                    if (value.status.toLowerCase() !== "processado") {
                        arrayMenssages.push(
                            `Rebalance não pode ser aprovado para a usina: ${value.nomeUsina} - ID: ${value.rebalanceUsinaID}`
                        );
                    } else {
                        listIds.push(value.rebalanceUsinaID);
                    }
                } else if (verb === "reopen") {
                    if (
                        value.status.toLowerCase() !== "aprovado" &&
                        value.status.toLowerCase() !== "enviado concessionária"
                    ) {
                        arrayMenssages.push(
                            `Rebalance não pode ser reaberto para a usina: ${value.nomeUsina} - ID: ${value.rebalanceUsinaID}`
                        );
                    } else {
                        listIds.push(value.rebalanceUsinaID);
                    }
                } else if (verb === "approveConcessionaria") {
                    if (value.status.toLowerCase() !== "enviado sankhya") {
                        arrayMenssages.push(
                            `Rebalance não pode aprovar concessionária para a usina: ${value.nomeUsina} - ID: ${value.rebalanceUsinaID}`
                        );
                    } else {
                        listIds.push(value.rebalanceUsinaID);
                    }
                } else if (verb === "sendConcessionaria") {
                    if (
                        value.status.toLowerCase() !== "aprovado" &&
                        value.status.toLowerCase() !== "enviado concessionária"
                    ) {
                        arrayMenssages.push(
                            `Rebalance não pode enviar concessionária para a usina: ${value.nomeUsina} - ID: ${value.rebalanceUsinaID}`
                        );
                    } else {
                        listIds.push(value.usinaID);
                    }
                }
            });
        }

        if (arrayMenssages.length > 0) {
            setDataMessages(arrayMenssages);
            return;
        }

        if (verb === "start" && enableRestartLines.length > 1) {
            setDataMessages(["Não é possível Reiniciar Rebalance em lote!"]);
            return;
        }

        // executa requisição
        const concatIds = listIds.join(",");

        let ciclo: any;
        let activeFilters: any = filters;

        if (activeFilters && activeFilters.cicloFaturamento) {
            ciclo = format(activeFilters.cicloFaturamento, "MM/yyyy");
        } else {
            ciclo = format(new Date(), "MM/yyyy");
        }

        if (verb === "start") {
            serviceStart(concatIds, ciclo);
        } else if (verb === "process") {
            serviceProcess(concatIds, ciclo);
        } else if (verb === "download") {
            serviceDownload(concatIds, ciclo);
        } else if (verb === "sankhya") {
            serviceSankhya(concatIds, ciclo);
        } else if (verb === "approve") {
            serviceApprove(concatIds);
        } else if (verb === "reopen") {
            serviceReopen(concatIds);
        } else if (verb === "approveConcessionaria") {
            serviceApproveConcessionaria(concatIds);
        } else if (verb === "sendConcessionaria") {
            serviceSendConcessionaria(concatIds, ciclo);
        }
    }

    useEffect(() => {
        if (dataMessages.length > 0) setInfoModal(true);
    }, [dataMessages]);

    const onClear = () => {
        setFilters(null);
        getAllWithFilters(null);
        const el = document.getElementsByClassName("MuiAutocomplete-clearIndicator")[1] as HTMLElement;
        if (el) {
            el.click();
        }
        reset({
            cicloFaturamento: null || new Date(),
            concessionariaID: "",
            status: "",
            usinasIds: "",
        });
    };

    const onSuccessAction = () => {
        getAllWithFilters(filters);
    };

    return (
        <Container>
            <Card>
                <CardContent>
                    <Box sx={{ mb: 2 }}>
                        <form onSubmit={handleSubmit(onSubmit)}>
                            <Grid container spacing={2}>
                                <Grid item md={12}>
                                    <Grid container spacing={2}>
                                        <Grid item xs={12} md={2}>
                                            <Datapicker
                                                name="cicloFaturamento"
                                                label="Referência"
                                                control={control}
                                                error={errors}
                                                format="MM/yyyy"
                                                view={["month", "year"]}
                                                noDateForward
                                            />
                                        </Grid>

                                        <Grid item xs={12} md={2}>
                                            <AutoComplete
                                                name="concessionariaID"
                                                label="Concessionária"
                                                options={concessionariaDataOptions}
                                                control={control}
                                                error={errors}
                                                onChange={(idConcessionaria) => {
                                                    if (idConcessionaria) {
                                                        getUsinaData({ concessionariaID: idConcessionaria });
                                                    }
                                                }}
                                            />
                                        </Grid>

                                        <Grid item xs={12} md={2}>
                                            <AutoCompleteMulti
                                                name="usinasIds[]"
                                                label="Usinas"
                                                options={usinaDataOptions}
                                                control={control}
                                                error={errors}
                                                limitTags={1}
                                            />
                                        </Grid>

                                        <Grid item md={2}>
                                            <AutoComplete
                                                name="tipoUsina"
                                                label="Tipo de usina"
                                                options={[
                                                    { label: "Todos", value: "Todos" },
                                                    { label: "Cooperativa", value: "Cooperativa" },
                                                    { label: "Consórcio", value: "Consórcio" },
                                                    { label: "AutoConsumo Remoto", value: "AutoConsumo Remoto" },
                                                ]}
                                                control={control}
                                                error={errors}
                                            />
                                        </Grid>

                                        <Grid item xs={12} md={2}>
                                            <AutoComplete
                                                name="status"
                                                label="Status"
                                                options={statusDataOptions}
                                                control={control}
                                                error={errors}
                                            />
                                        </Grid>

                                        <Grid item md={2}>
                                            <Button
                                                disableElevation
                                                variant="contained"
                                                color="warning"
                                                fullWidth
                                                style={{ margin: "16px 0px 8px 0px" }}
                                                startIcon={<Search />}
                                                type="submit"
                                                disabled={isLoading}
                                            >
                                                Pesquisar
                                            </Button>
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </form>
                        <Grid container spacing={2}>
                            <Grid item md={12}>
                                <Grid container spacing={2}>
                                    <Grid item md={2}>
                                        <Button
                                            disableElevation
                                            variant="contained"
                                            color="primary"
                                            fullWidth
                                            style={{ margin: "16px 0px 8px 0px" }}
                                            startIcon={<PlayCircle />}
                                            onClick={() => execList("start")}
                                            disabled={linesSelecteds.length <= 0 || iniciarDisabled}
                                        >
                                            Iniciar
                                        </Button>
                                    </Grid>
                                    <Grid item md={2}>
                                        <ButtonDownload
                                            onClick={() => execList("download")}
                                            disabled={linesSelecteds.length <= 0 || downloadDisabled}
                                        />
                                    </Grid>
                                    <Grid item md={2}>
                                        <Button
                                            disableElevation
                                            variant="contained"
                                            color="primary"
                                            fullWidth
                                            style={{ margin: "16px 0px 8px 0px" }}
                                            startIcon={<FileUploadOutlined />}
                                            onClick={() => setOpenImport(true)}
                                        >
                                            Importar
                                        </Button>
                                    </Grid>

                                    <Grid item md={2}>
                                        <Button
                                            disableElevation
                                            variant="contained"
                                            color="primary"
                                            fullWidth
                                            style={{ margin: "16px 0px 8px 0px" }}
                                            startIcon={<Settings />}
                                            onClick={() => execList("process")}
                                            disabled={linesSelecteds.length <= 0 || processarDisabled}
                                        >
                                            processar
                                        </Button>
                                    </Grid>

                                    <Grid item md={2}>
                                        <Button
                                            disableElevation
                                            variant="contained"
                                            color="primary"
                                            fullWidth
                                            style={{ margin: "16px 0px 8px 0px" }}
                                            startIcon={<CheckCircle />}
                                            onClick={() => execList("approve")}
                                            disabled={linesSelecteds.length <= 0 || aprovarDisabled}
                                        >
                                            Aprovar
                                        </Button>
                                    </Grid>

                                    <Grid item md={2}>
                                        <Button
                                            disableElevation
                                            variant="outlined"
                                            color="warning"
                                            fullWidth
                                            style={{ margin: "16px 0px 8px 0px" }}
                                            startIcon={<Clear />}
                                            onClick={() => onClear()}
                                        >
                                            Limpar
                                        </Button>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid>
                        <Grid container spacing={2}>
                            <Grid item md={12}>
                                <Grid container spacing={2}>
                                    <Grid item md={2}>
                                        <Button
                                            disableElevation
                                            variant="contained"
                                            color="primary"
                                            fullWidth
                                            style={{ margin: "16px 0px 8px 0px" }}
                                            startIcon={<DriveFileMoveRounded />}
                                            onClick={() => execList("reopen")}
                                            disabled={linesSelecteds.length <= 0 || reabrirDisabled}
                                        >
                                            Reabrir
                                        </Button>
                                    </Grid>

                                    <Grid item md={2}>
                                        <Button
                                            disableElevation
                                            variant="contained"
                                            color="primary"
                                            fullWidth
                                            style={{ margin: "16px 0px 8px 0px" }}
                                            startIcon={<Mail />}
                                            onClick={() => execList("sendConcessionaria")}
                                            disabled={linesSelecteds.length <= 0 || enviarDisabled}
                                        >
                                            Enviar Con.
                                        </Button>
                                    </Grid>
                                    <Grid item md={2}>
                                        <Button
                                            disableElevation
                                            variant="contained"
                                            color="primary"
                                            fullWidth
                                            style={{ margin: "16px 0px 8px 0px" }}
                                            startIcon={<Send />}
                                            onClick={() => execList("sankhya")}
                                            disabled={linesSelecteds.length <= 0 || sankhyaDisabled}
                                        >
                                            Sankhya
                                        </Button>
                                    </Grid>
                                    <Grid item md={2}>
                                        <Button
                                            disableElevation
                                            variant="contained"
                                            color="primary"
                                            fullWidth
                                            style={{ margin: "16px 0px 8px 0px" }}
                                            startIcon={<DoneAll />}
                                            onClick={() => execList("approveConcessionaria")}
                                            disabled={linesSelecteds.length <= 0 || aprovConcDisabled}
                                        >
                                            Aprov. Conc
                                        </Button>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Box>

                    <Box sx={{ height: 450 }}>
                        <DataTable
                            columns={columns}
                            rows={data}
                            rowId={(row: GridRowModel) => row.rebalanceUsinaID}
                            rowCount={rowCount}
                            isLoading={isLoading}
                            onPageChange={(currentPage: number) => setPage(currentPage)}
                            onPageSizeChange={(currentPageSize: number) => setPageSize(currentPageSize)}
                            pageSize={pageSize}
                            initialState={{ pinnedColumns: { right: ["Operação", "operations"] } }}
                            checkboxSelection
                            onRowSelectionModelChange={(newSelectionModel) => {
                                setLinesSelecteds(newSelectionModel);
                            }}
                            rowSelectionModel={linesSelecteds}
                            onSortModelChange={(model: GridSortModel) => setSortModel(model)}
                        />
                    </Box>
                </CardContent>
            </Card>

            {infoModal && (
                <DialogInfo
                    data={dataMessages}
                    onClose={() => {
                        setInfoModal(false);
                        setDataMessages([]);
                    }}
                />
            )}

            {confirmRestartModal && (
                <DialogConfirmRestart
                    data={confirmRestartState}
                    onClose={() => {
                        setConfirmRestartModal(false);
                        setConfirmRestartState({
                            nomeUsina: "",
                            rebalanceUsinaID: 0,
                            usinaID: 0,
                            cicloFaturamento: "",
                        });
                    }}
                    onSuccess={() => onSuccessAction()}
                />
            )}

            {openImport && (
                <DialogLoad
                    onClose={() => {
                        setOpenImport(false);
                    }}
                    onSuccess={() => onSuccessAction()}
                />
            )}

            <DialogError
                open={errorState.open}
                onSuccess={() => onSuccessAction()}
                data={{
                    open: errorState.open,
                    id: errorState.id,
                    error: errorState.error,
                    rebalanceUsinaID: errorState.rebalanceUsinaID,
                }}
                onClose={() => {
                    setErrorState({ open: false, id: "", error: "", rebalanceUsinaID: "" });
                }}
            />

            <DialogGanhoFinanceiro
                open={ganhoFinanceiroModal}
                data={ganhoFinanceiroState}
                onClose={() => {
                    setGanhoFinanceiroModal(false);
                    setGanhoFinanceiroState({ usinaID: 0, mes: "", ano: "" });
                }}
            />
        </Container>
    );
};

export default Rebalance;
